import React from "react";
import { Card, CardBody, Container, Row, Col, Button } from "reactstrap";
import { getStats } from "../../components/helpers/StatsHelpers";
import { RiShare2Line } from "react-icons/ri";
import { SeoHelper } from "../../components/helpers/SeoHelper";
import InstructionsWizard from "./InstructionsWizard";

class SharingASongFlowHelp extends React.Component {
  state = { songBookCount: null };

  constructor(props) {
    super(props);
    getStats.call(this);
  }

  stepsData = [
    {
      title: "Sharing a song-flow",
      description:
        "At the end of this guide you will be able to:<br/><br/>" +
        "<img src=\"/help-images/blue-arrow.png\" style=\"width: 40px; height: auto;\">&nbsp;" +
        "share a curated song-flow with your team or church by email" +
        "<br/><br/>Free accounts can share a song-flow up to 3 times in total. Paid accounts can share without limit.",
    },
    {
      title: "Open your song-flow",
      description:
        "Navigate to the song-flow you would like to share. If you have a saved song-flow, go to <b>Your Account</b> in the navigation bar and select <b>View your saved song-flows</b>, then open the one you want to share." +
        "<br/><br/>If you have just built a song-flow, you can share it directly from the song-flow page.",
    },
    {
      title: "Click the Share button",
      description:
        "On the song-flow page, find and click the <b>Share</b> button. A sharing panel will appear where you can enter the details of the people you would like to send the song-flow to.",
    },
    {
      title: "Enter email address",
      description:
        "Enter the name and email address of the person you would like to share your song-flow with. You can add multiple recipients by clicking <b>Add another recipient</b>.",
    },
    {
      title: "Send the song-flow",
      description:
        "Once you have added your recipients, click <b>Send</b>. Each person will receive an email containing a link to view your curated song-flow.",
    },
    {
      title: "What your recipients receive",
      description:
        "Your recipients will receive an email from The Worship Bible containing a direct link to your song-flow. " +
        "They do not need an account to view it — the link gives them a read-only view of the song-flow you have built.",
    },
    {
      title: "Share limits",
      description:
        "Free accounts have a total share limit of 3. Once this limit is reached, sharing is no longer available without upgrading." +
        "<br/><br/>Paid accounts — Single User, Group, and Organisation — can share song-flows an unlimited number of times. " +
        "To upgrade your account, visit the <a href='/register/choose-your-plan'>plans page</a>.",
    },
    {
      title: "What's next",
      description:
        "Your song-flow has been shared with your team." +
        "<br/><br/><img src=\"/help-images/star.png\" style=\"width: 40px; height: auto;\"> <a href='/help/saving-and-managing-your-song-flows'>Save and manage your song-flows</a>" +
        "<br/><br/><img src=\"/help-images/star.png\" style=\"width: 40px; height: auto;\"> <a href='/help/reordering-songs-in-your-song-flow'>Reorder songs in your song-flow</a>" +
        "<br/><br/><img src=\"/help-images/star.png\" style=\"width: 40px; height: auto;\"> View our other <a href='/help'>help articles</a> for more guidance.",
      image: "/help-images/well-done.png",
      enlargeable: false,
    },
  ];

  render() {
    return (
      <>
        <SeoHelper
          uri="/help/sharing-a-song-flow"
          title="Sharing a song-flow | Help | The Worship Bible"
          description="How to share a curated song-flow with your team or church by email."
        />
        <div className="position-relative">
          <section className="section section-lg section-shaped pb-250">
            <div className="shape shape-style-1 shape-default">
              <span/><span/><span/><span/><span/><span/><span/><span/><span/>
            </div>
            <Container className="py-lg-md d-flex">
              <div className="col px-0">
                <Row>
                  <Col lg="8">
                    <h1 className="display-3 text-white">
                      Building your song-flows{" "}<span>help</span>
                    </h1>
                  </Col>
                </Row>
              </div>
            </Container>
            <div className="separator separator-bottom separator-skew">
              <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" version="1.1" viewBox="0 0 2560 100" x="0" y="0">
                <polygon className="fill-white" points="2560 0 2560 100 0 100"/>
              </svg>
            </div>
          </section>
        </div>
        <section className="section section-lg pt-lg-0 mt--200">
          <Container>
            <Row className="justify-content-center">
              <Col lg="12">
                <Row className="row-grid">
                  <Col lg="12">
                    <Card className="card-lift--hover shadow border-0">
                      <CardBody className="py-5">
                        <Row className="mt-3">
                          <Col>
                            <div className="d-flex align-items-center mb-3">
                              <RiShare2Line color="#5e72e4" size="24" className="mr-2"/>
                              <h2 style={{fontSize: "1rem"}} className="text-primary mb-0">Sharing a song-flow</h2>
                            </div>
                          </Col>
                          <Col md="3" xs="12">
                            <Button block type="button" className="mb-2" color="white" href="/help">
                              <span className="btn-inner--text">Back to help</span>
                            </Button>
                          </Col>
                        </Row>
                        <InstructionsWizard stepsData={this.stepsData}/>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </section>
      </>
    );
  }
}

export default SharingASongFlowHelp;
